import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    pdfUrl: null,
    menuStatistics: {
      disbarments: 0,
      orders: 0,
      prolongations: 0,
    },
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    getPdfUrl: state => {
      const { pdfUrl } = state
      return pdfUrl
    },
    getMenuStatistics: statistics => {
      const { menuStatistics } = statistics
      return menuStatistics
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    UPDATE_PDF_URL(state, val) {
      state.pdfUrl = val
    },
    UPDATE_MENU_STATISTICS(state, val) {
      state.menuStatistics = val
    },
  },
  actions: {},
}
